import { render, staticRenderFns } from "./how-to-bid-online.vue?vue&type=template&id=045b86d6&"
import script from "./how-to-bid-online.vue?vue&type=script&lang=js&"
export * from "./how-to-bid-online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports